import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { inputSliceActions, selectIndirectAssistCheckbox } from 'features/input/inputSlice';

import Checkbox from 'atoms/input/Checkbox';
import { IndirectAssistCheckboxTypes } from './IndirectAssistCheckboxTypes';

const IndirectAssistCheckbox: React.FC<IndirectAssistCheckboxTypes> = ({ disabled }) => {
  const dispatch = useDispatch();

  const indirectAssistCheckboxChecked = useSelector(selectIndirectAssistCheckbox);

  const check = () => {
    dispatch(inputSliceActions.setIndirectAssistCheckbox(!indirectAssistCheckboxChecked));
  };

  return (
    <div id="indirect-assist-checkbox">
      <Checkbox
        checked={indirectAssistCheckboxChecked}
        onChange={check}
        disabled={disabled}
        formattedMessageId="checkboxes.indirectAssist"
      />
    </div>
  );
};

export default IndirectAssistCheckbox;
